import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

class ScrollTriggerClass {
  constructor(elms) {
    this.dom = {elms: elms};

    gsap.registerPlugin(ScrollTrigger);

    this.init();
  }

  init() {
    [...this.dom.elms].forEach((el, index) => {
      ScrollTrigger.create({
        trigger: el,
        id: index + 1,
        start: 'top 70%',
        toggleClass: {
          targets: el,
          className: 'is-show'
        },
        once: true,
        markers: false,
      });
    });
  }
}

export default ScrollTriggerClass